<template>
	<div class='common-right-wrap'>
		<div class="search-wrap">
			<div class="search-title">合同搜索</div>
			<el-input v-model="contract" placeholder="请输入完整的合同编号或合同名称">
				<el-button slot="append" icon="el-icon-search" @click="creditSearchHandler"></el-button>
			</el-input>
		</div>
		<div class="look-wrap wrap-border">
			<div class="border-5">
				<div class="active">
					<i class="el-icon-tickets"></i>热点资讯
				</div>
			</div>
			<div class="recommend-wrap">
				<ul>
					<li class="" v-for="(item, index) in currentTrends" :key="item.id">
						<router-link class="index-top-flex" :to="`/common/article/1/${item.id}`">
							<div class="flex flex-row-between" >
								<p >{{ item.title }}</p>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { getDynamicsHot } from '@/api';

export default {
	components: {},
	data() {
		return {
			contract: undefined,
			headlines: [],
		}
	},
	props: {},
	created() { },
	mounted() {
		this.getIndexData();
	},
	methods: {
		creditSearchHandler() {
			if (this.contract) {
				this.$router.push({
					name: 'searchContract',
					query: {
            contractNumber: this.contract
					}
				})
			}
		},
		getIndexData() {
			getDynamicsHot().then((res) => {
				this.$set(this, 'headlines', res);
			});
		},
	},
	computed: {
		currentTrends() {
			return this.headlines;
		},
	},
	watch: {
	},
}
</script>
<style lang='scss'>
	$red: #d01c0b;
	.common-right-wrap {
		width: 100%;
		.search-wrap {
			background-color: #e0e7ed;
			padding: 15px;
			.search-title {
				font-weight: 600;
				text-align: left;
				font-size: 18px;
			}

			.el-input {
				width: 370px;
				margin: 20px auto 10px;
				height: 40px;
				.el-input__inner {
					border-color: #ccc;
					height: 40px;
					line-height: 40px;
					border-right: none;
				}
				.el-input-group__append {
					border-color: #ccc;
					height: 40px;
					background-color: #fff;
					border-left: none;
					.el-icon-search {
						color: #d8e1e9;
					}
				}
			}
		}

		.look-wrap {
			padding: 20px;
			margin-top: 20px;
            text-align: center;

			.active {
				width: 35%;
				padding: 0 10px 5px;
				text-align: left;
				i {
					font-size: 28px;
					font-weight: bold;
					color: $red;
					margin-right: 4px;
				}
			}

			.link-title {
				text-align: left;
				margin: 18px 0;
				i {
					font-size: 25px;
					font-weight: bold;
					color: $red;
					margin-right: 4px;
				}
			}
			.server-search {
				width: 100%;
				margin-bottom: 15px;
				height: 40px;
				.el-input-group__prepend {
					padding: 0 0 0 5px;
					width: 25%;
					flex-shrink: 0;
					border: 1px solid $red;
					border-right: none;
					background-color: #fff;
					font-size: 14px;
					.el-select {
						width: 100%;
						.el-input {
							width: 100%;
							.el-input__inner {
								padding: 0;
								font-size: 13px;
							}
						}
					}
				}
				.el-input__inner {
					font-size: 14px;
				}
			}
			.link-wrap {
				.flex {
					flex-basis: 49%;
					margin: 10px 0;
					padding: 15px 0;
					& > img {
						& + p {
							margin-left: 20px;
						}
					}
				}
			}

			& > .recommend-wrap {
				overflow-x: hidden;
				overflow-y: auto;
				& > .flex {
					position: relative;
					margin-top: 15px;
					padding-left: 20px;
					cursor: pointer;
					&:first-of-type {
						color: $red;
					}
					&:nth-child(2) {
						color: #ffa13e;
					}
					&::before {
						content: '';
						width: 8px;
						height: 8px;
						border-radius: 50%;
						background: $red;
						position: absolute;
						top: 7px;
						left: 0;
					}

					& > p {
						text-align: left;
					}
					& > img {
						margin-left: 10px;
					}
				}
				& > ul {
						& > li {
							& > .index-top-flex {
								border-bottom: 1px dotted #ccc;
								display: block;
							}
							& > .index-top-flex {
								line-height: 45px;
								//padding-left: 20px;
								position: relative;
								&:hover {
									color: $red;
								}
								p {
									flex-basis: 99%;
									text-align: left;
									letter-spacing: 1px;
    								line-height: 30px;
									//&::before {
									//	content: '头条新闻';
									//	font-size: 12px;
    							//		color: #a88857;
    							//		display: inline-block;
    							//		vertical-align: middle;
    							//		padding: 0 12px;
    							//		height: 24px;
    							//		line-height: 24px;
    							//		border-radius: 5px;
    							//		border: 1px solid #a88857;
    							//		box-sizing: border-box;
    							//		margin-right: 5px;
    							//		cursor: default;
									//}
								}
							}
						}
					}
			}
		}
	}
</style>
